import { DarkTheme } from "@react-navigation/native"
import light from './light-theme'
import climateFirst from './climate-first'
import dark from './dark-theme'

export const NavigationTheme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    background: 'black',
    card: dark.colors.navigationPrimary,
    primary: dark.colors.primary,
  },
}

// this doesn't work because default exports are statically bound
export default light

export { light, dark, climateFirst }